import type { DeliveryChannel } from "../types";

export function isEnabledFeatureFlag(value: string | undefined): boolean {
  return value?.trim().toLowerCase() === "true";
}

/**
 * This flag changes only the administration UI. SMS/WhatsApp types, API
 * contracts, stored configuration, providers and worker routes remain intact.
 */
export const SHOW_TWILIO_ADMIN = isEnabledFeatureFlag(import.meta.env.VITE_SHOW_TWILIO_ADMIN);

export function isNotificationChannelVisibleInAdmin(
  channel: DeliveryChannel,
  showTwilioAdmin = SHOW_TWILIO_ADMIN,
): boolean {
  return showTwilioAdmin || (channel !== "sms" && channel !== "whatsapp");
}
